import { Injectable} from '@angular/core';
import { Subject } from 'rxjs';
import { NavGuardService } from '../components/navigation/nav.gaurd.service';
import { Router } from '@angular/router';


@Injectable()
export class NavigationService{


    private options = new Subject<{action:string,title:string,disabled:boolean}[]>();
    private optionAction = new Subject<{action:string}>();
    private updateOption = new Subject<{action:string,title:string,disabled:boolean}>();

    private updateSidNavFilters:boolean = true;
    private updateNavOptions:boolean = true;
    private subtitle = new Subject<string>();
    private newTabLink = new Subject<string>();
    private footerMsg = new Subject<string>();
    
    public setOptions$ = this.options.asObservable();
    public optionAction$ = this.optionAction.asObservable();
    public updateOption$ = this.updateOption.asObservable();
    
    
    // public sideNavFilters$ = this.sideNavFilters.asObservable();
    // public sideNavFilterValues$ = this.filterValues.asObservable();

    public subtTitle$ = this.subtitle.asObservable();
    public newTabLink$ = this.newTabLink.asObservable();
    public footerMsg$ = this.footerMsg.asObservable();

    constructor(private navGaurd:NavGuardService, private router:Router){

    }

    setOptions(options:{action:string,title:string,disabled:boolean}[]){
        this.options.next(options);
    }

    optionActionClicked(action:{action:string}){
        this.optionAction.next(action);
    }

    updateOptionList(action:{action:string,title:string,disabled:boolean}){
        this.updateOption.next(action);
    }

    // setSideNavFilters(filters:AdvanceFilter[]){
    //     let filterValues = filters.slice(0,filters.length);
    //     this.sideNavFilters.next(filterValues);
    // }

    // setSideNavFilterValues(fv:AdvanceFilterRecord[]){
    //     let fvs = fv.slice(0,fv.length);
    //     this.filterValues.next(fvs);
    // }

    setUpdateSideNavFilters(tf:boolean){
        this.updateSidNavFilters = tf;
    }

    canUpdateSideNavFilters(){
        return this.updateSidNavFilters;
    }

    setUpdateNavOptions(tf:boolean){
        this.updateNavOptions = tf;
    }

    canUpdateNavOptions(){
        return this.updateNavOptions;
    }

    // resetNavFilters(){
    //     if(this.canUpdateSideNavFilters()){
    //         this.setSideNavFilterValues([]);
    //         this.setSideNavFilters([]);
    //     }
    // }

    resetNavOptions(){
        if(this.canUpdateNavOptions()){
            this.setOptions([]);
        }
    }

    resetNav(){
        // this.resetNavFilters();
        this.resetNavOptions();
    }

    setSubTitle(title:string){
        this.subtitle.next(title);
    }

    setFooterMsg(msg:string){
        this.footerMsg.next(msg);
    }

    clearFooterMsg(){
        this.footerMsg.next("...")
    }

    openPageInNewTab(link:string){
        this.newTabLink.next(link);
    }

    getMenuTree():MenuTreeItem[]{
        let menuTree:MenuTreeItem[]=[];

        menuTree.push(
            new MenuTreeItem({title:"Delivery Rate",link:"",icon:"report",openNewTab:false,
                subItems:[
                    new MenuTreeItem({title:"New",link:"insuranceClaims/new/empty",icon:"add",openNewTab:false,subItems:[]}),
                    new MenuTreeItem({title:"Search",link:"insuranceClaims/search",icon:"search",openNewTab:false,subItems:[]}),
                    new MenuTreeItem({title:"Reports",link:"insuranceClaims/reports",icon:"analytics",openNewTab:false,subItems:[]})
                ]
            })
        );

        // menuTree.push(
        //     new MenuTreeItem({title:"Reports",link:"",icon:"analytics",openNewTab:false,
        //         subItems:[
        //             new MenuTreeItem({title:"Insurance Claims",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Property Claims",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Work Comp Report",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"List of Deleted Records",link:"changeme",openNewTab:false,icon:"",subItems:[]}),
        //             new MenuTreeItem({title:"Open Property Report - No W/C",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Open Fleet",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Open General Liability",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Open Work Comp",link:"changeme",icon:"",openNewTab:false,subItems:[]}),
        //             new MenuTreeItem({title:"Open Property",link:"changeme",icon:"",openNewTab:false,subItems:[]})
        //         ]
        //     })
        // );

        // menuTree.push(
        //     new MenuTreeItem({title:"Rental",link:"",icon:"house",
        //         subItems:[
        //             new MenuTreeItem({title:"New",link:"changeme",icon:"add",subItems:[]}),
        //             new MenuTreeItem({title:"Search",link:"changeme",icon:"search",subItems:[]}),
        //             new MenuTreeItem({title:"Reports",link:"changeme",icon:"analytics",subItems:[]})
        //         ]
        //     })
        // );
    

        return menuTree;
    }

    public setDirtyPage(tf:boolean){
        this.navGaurd.setPageIsDirty(tf);
    }

    public updateLocation(urlPath:string){
        this.navGaurd.updateLocation(urlPath);
    }

    public setMemoryObjectToken(tokenUid:string){
        this.navGaurd.setMemToken(tokenUid);
    }

    public navigateTo(path:string){
        this.router.navigate([path])
    }

}
export class MenuTreeItem{
    public title:string;
    public link:string;
    public icon:string;
    public openNewTab:boolean;
    public subItems:MenuTreeItem[];

    constructor(data?:{title:string,link:string,icon:string, openNewTab:boolean ,subItems:MenuTreeItem[]}){
        this.title = "";
        this.link = "";
        this.icon = "";
        this.openNewTab = false;
        this.subItems = [];

        if(typeof data != "undefined"){
            this.title = data.title;
            this.link = data.link;
            this.icon = data.icon;
            this.openNewTab = data.openNewTab;
            this.subItems = data.subItems;
        }
    }
}
